module.exports = __webpack_public_path__ + "img/qrcode-cw.21bca0e8.png";